<template>
  <div v-if="card" class="bg-white rounded-lg border border-gray-200 overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-200">
      <h3 class="text-sm font-semibold text-gray-900">Hospital Affiliations</h3>
    </div>
    <div class="p-4">
      <div v-for="section in card.sections.filter(s => s.type === 'table')" :key="section.title">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="text-left text-xs text-gray-500 uppercase border-b border-gray-200">
              <th v-for="col in section.columns" :key="col" class="pb-1 pr-3">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in section.rows" :key="i" class="border-b border-gray-200">
              <td v-for="(cell, j) in row" :key="j" class="py-1 pr-3">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-for="section in card.sections.filter(s => s.type === 'key_value')" :key="section.label" class="mt-3 text-sm text-gray-500">
        <span class="font-medium text-gray-900">{{ section.value }}</span>
        <span v-if="section.subtitle" class="ml-1">{{ section.subtitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PracticeHospitals',
  props: {
    insights: { type: Object, default: null },
  },
  computed: {
    card() {
      if (!this.insights?.cards) return null
      return this.insights.cards.find(c => c.id === 'hospital_affiliation' && c.available)
    },
  },
}
</script>
